import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { akEditorFloatingDialogZIndex, akEditorMobileMaxWidth, akEditorSwoopCubicBezier, FULL_PAGE_EDITOR_TOOLBAR_HEIGHT } from '@atlaskit/editor-shared-styles';
import { fg } from '@atlaskit/platform-feature-flags';
export var MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 868;

// box-shadow is overriden by the mainToolbar
var mainToolbarWithKeyline = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"
});
var mainToolbarTwoLineStyle = function mainToolbarTwoLineStyle() {
  var editorToolbarHeight = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT();
  return css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
    flexWrap: 'wrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: "calc(".concat(editorToolbarHeight, " * 2)")
  }));
};
var flexibleIconSize = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '& span svg': {
    maxWidth: '100%'
  }
});
var mainToolbar = function mainToolbar() {
  var editorToolbarHeight = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT();
  return css(_defineProperty({
    position: 'relative',
    alignItems: 'center',
    boxShadow: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBottom: "1px solid ".concat("var(--ds-border, #091E4224)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: "box-shadow 200ms ".concat(akEditorSwoopCubicBezier),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: akEditorFloatingDialogZIndex,
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: editorToolbarHeight,
    flexShrink: 0,
    backgroundColor: "var(--ds-surface, white)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& object': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
      height: '0 !important'
    }
  }, "@media (max-width: ".concat(akEditorMobileMaxWidth, "px)"), {
    display: 'grid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: "calc(".concat(editorToolbarHeight, " * 2)")
  }),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/ui-styling-standard/no-unsafe-values
  fg('platform-visual-refresh-icons') && flexibleIconSize);
};
export var mainToolbarStyle = function mainToolbarStyle(showKeyline, twoLineEditorToolbar) {
  return [mainToolbar, showKeyline && mainToolbarWithKeyline, twoLineEditorToolbar && mainToolbarTwoLineStyle];
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var mainToolbarIconBeforeStyle = css(_defineProperty({
  margin: "var(--ds-space-200, 16px)",
  height: "var(--ds-space-400, 32px)",
  width: "var(--ds-space-400, 32px)"
}, "@media (max-width: ".concat(akEditorMobileMaxWidth, "px)"), {
  gridColumn: 1,
  gridRow: 1
}));
var mainToolbarFirstChild = css(_defineProperty({
  display: 'flex',
  flexGrow: 1
}, "@media (max-width: ".concat(akEditorMobileMaxWidth, "px)"), {
  gridColumn: 1,
  gridRow: 1
}));
var mainToolbarFirstChildTowLine = function mainToolbarFirstChildTowLine() {
  var editorToolbarHeight = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT();
  return css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
    flex: '1 1 100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: editorToolbarHeight,
    justifyContent: 'flex-end',
    minWidth: 'fit-content'
  }));
};
export var mainToolbarFirstChildStyle = function mainToolbarFirstChildStyle(twoLineEditorToolbar) {
  return [mainToolbarFirstChild, twoLineEditorToolbar && mainToolbarFirstChildTowLine];
};
var mainToolbarSecondChild = css({
  minWidth: 'fit-content'
});
var mainToolbarSecondChildTwoLine = function mainToolbarSecondChildTwoLine() {
  var editorToolbarHeight = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT();
  return css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
    display: 'flex',
    flexGrow: 1,
    flex: '1 1 100%',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: editorToolbarHeight,
    minWidth: 0
  }));
};
export var mainToolbarSecondChildStyle = function mainToolbarSecondChildStyle(twoLineEditorToolbar) {
  return [mainToolbarSecondChild, twoLineEditorToolbar && mainToolbarSecondChildTwoLine];
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var nonCustomToolbarWrapperStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var customToolbarWrapperStyle = css({
  alignItems: 'center',
  display: 'flex'
});